import { COUNTRIES } from '@wareclouds/frontend-common';
import { CONTEXT } from '../../../../config/consts/commons';
import { BankAccountFormCl } from '../ui/components/BankAccountFormCl';
import { BankAccountFormBr } from '../ui/components/BankAccountFormBr';

const countryForms = {
  [COUNTRIES.CL]: BankAccountFormCl,
  [COUNTRIES.BR]: BankAccountFormBr,
};

export const useFormRenderFromContext = () => {
  const BankAccountForm = countryForms[CONTEXT] || null;

  return {
    BankAccountForm,
  };
};
